module.exports = __webpack_public_path__ + "static/ecosystem-mobile-8ea32c08c7a3c631e89717246d091830.png";